import * as yup from 'yup';

export const breakFormSchema = yup.object().shape({
  date: yup
    .string()
    .required(),
  note: yup
    .string()
    .nullable()
    .defined(),
  employee: yup
    .string()
    .required(),
  title: yup
    .string()
    .nullable()
    .required(),
  recurring: yup
    .string()
    .nullable()
    .defined(),
  from: yup
    .number()
    .nullable()
    .required(),
  to: yup
    .number()
    .nullable()
    .required(),
});
